'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _controlField = require('../../hocs/control-field');
var _controlField2 = _interopRequireDefault(_controlField);
var _constants = require('../../constants');
var _formField = require('../form-field');
var _formField2 = _interopRequireDefault(_formField);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var SplitField = function (_Component) {
  _inherits(SplitField, _Component);
  function SplitField(props) {
    _classCallCheck(this, SplitField);
    var _this = _possibleConstructorReturn(this, (SplitField.__proto__ || Object.getPrototypeOf(SplitField)).call(this, props));
    _this.handleChange = function (position) {
      return function (value) {
        var values = [].concat(_toConsumableArray(_this.props.value));
        values[_this.accountForPreset(position)] = value;
        _this.props.control(values);
      };
    };
    _this.handleBlur = function (position) {
      var last = _this.totalCount() - 1;
      // Values should be strings.
      // But we check for an empty string.
      // In case the last value is a number
      if (_this.accountForPreset(position) === last || _this.props.value[last] !== '') {
        _this.props.validate();
        typeof _this.props.onBlur !== 'undefined' && _this.props.onBlur();
      }
    };
    if (props.value.length !== _this.totalCount()) {
      // Create an array of empty strings if values are not set.
      // We use a for loop just to make sure, forEach may potentially skip empty array elements
      var values = [].concat(_toConsumableArray(props.presetValues));
      for (var i = 0; i < props.valueCount; i++) {
        var value = props.value[i];
        if (typeof value !== 'undefined') {
          values.push(value);
        } else {
          values.push('');
        }
      }
      props.control(values);
    }
    return _this;
  }
  _createClass(SplitField, [{
    key: 'totalCount',
    value: function totalCount() {
      return this.props.valueCount + this.props.presetValues.length;
    }
  }, {
    key: 'accountForPreset',
    value: function accountForPreset(position) {
      return position + this.props.presetValues.length;
    }
  }, {
    key: 'removePreset',
    value: function removePreset() {
      var copy = [].concat(_toConsumableArray(this.props.value));
      copy.splice(0, this.props.presetValues.length);
      return copy;
    }

    // Each input fires handleChange on render to set position
    // Then provides the value on actual change

    // Position has to be provided by the input
    // Then we fire validation after checking to see if it's the last input, or if the last input has a value
  }, {
    key: 'render',
    value: function render() {
      // render is a function - we give it the arguments.
      // the parent can then use these arguments to render whatever children it likes
      var _props = this.props,
        label = _props.label,
        error = _props.error,
        name = _props.name,
        validating = _props.validating,
        render = _props.render,
        helpText = _props.helpText,
        disabled = _props.disabled,
        fieldCss = _props.fieldCss;
      var valid = typeof error !== 'undefined' ? !error.length : undefined;
      return _react2.default.createElement(_formField2.default, {
        label: label,
        error: error,
        name: name,
        validating: validating,
        helpText: helpText,
        disabled: disabled,
        css: fieldCss
      }, render(this.removePreset(), valid, this.handleChange, this.handleBlur));
    }
  }]);
  return SplitField;
}(_react.Component);
SplitField.propTypes = Object.assign({}, _constants.fieldPropTypes, {
  value: (0, _propTypes.arrayOf)(_propTypes.string),
  render: _propTypes.func.isRequired,
  valueCount: _propTypes.number.isRequired,
  presetValues: (0, _propTypes.arrayOf)(_propTypes.string),
  onBlur: _propTypes.func
});
SplitField.defaultProps = Object.assign({}, _constants.defaultFieldPropTypes, {
  value: [],
  presetValues: [],
  onBlur: undefined
});
exports.default = (0, _controlField2.default)(SplitField);